import React from 'react';
import ReactDOM from 'react-dom';

class RadioList extends React.Component {
  constructor(props) {
    super(props);
    this.renderRadio = this.renderRadio.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }
  renderRadio(model) {
    var spanclass = "";
    if(model.Disabled)
    {
     spanclass="btn btn-sm col-12";
    }else 
    if(model.Selected)
    {
       spanclass="btn btn-sm btn-primary col-12";
    }else{
      spanclass="btn btn-sm col-12";
    }
    
    return ( <label className="col-4" key={model.Name}>
      <input className="d-none" name={this.props.radioGroupName} type="radio" defaultChecked={model.Selected} value={model.Value} disabled={model.Disabled}/>
     
      <span className={spanclass}>
        {model.Name} 
        {this.props.includeCount && (
          <text>({model.Count})</text>
        )}
        
        </span>
    </label>);
  } 
  onChangeValue(event) {
    this.props.onChange(event.target.value);
  }
  render() {
    
      let options= [];
        if(this.props.options){
        options = this.props.options.map(function(obj, i){
          return this.renderRadio(obj);
        }.bind(this) );
      
      }
    return (

      // <div className="btn-group justified-content g-mb-40"  onChange={this.onChangeValue}>
      <div className="btn-group col-12"  onChange={this.onChangeValue}>
        { options }
      </div>

    );
  }
}
export default RadioList;

